module.exports = __webpack_public_path__ + "static/media/i5a.4b1938ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i5a.svg
// module id = 404
// module chunks = 12